import { API_METHODS } from 'constants/api-methods'
import { BASE_API_URL } from 'constants/env'
import { store } from 'index'
import toast from 'react-hot-toast'
import { useMutation, useQueryClient } from 'react-query'
import { apiHeaders } from 'utils/api-headers'
import { handleErrors } from 'utils/handle-errors'
import { organizationsKeys } from 'utils/query-keys'

interface AddPaymentIntentParams {
  customerId: string
  intent: string
  usage: string
}

interface AddPaymentIntentResponse {
  client_secret: string
}
const addPaymentIntent = async (
  data: AddPaymentIntentParams
): Promise<AddPaymentIntentResponse> => {
  let response = await fetch(`${BASE_API_URL}/admin/api/v2/setup-intent`, {
    method: API_METHODS.POST,
    headers: apiHeaders(store.getState()),
    body: JSON.stringify({
      customer_id: data.customerId,
      intent: data.intent,
      usage: data.usage,
    }),
  })

  response = handleErrors(response)

  return response.json()
}

const useAddPaymentIntent = (organizationId?: string) => {
  const queryClient = useQueryClient()
  return useMutation(
    ({ data }: { data: AddPaymentIntentParams }) => {
      return addPaymentIntent(data)
    },
    {
      onSuccess: async () => {
        toast('Payment intent added', { icon: `👍` })
        if (organizationId) {
          queryClient.invalidateQueries(
            organizationsKeys.stripePaymentMethods.detail(organizationId)
          )
        }
      },
      onError: () => {
        toast.error(
          'Error adding payment intent. Open the console and take a screenshot and send to linq engineers.'
        )
      },
    }
  )
}

export default useAddPaymentIntent
